export default __webpack_public_path__ + "static/media/16.1bced81a.png";